module.exports = __webpack_public_path__ + "img/F911.da6aecd9.jpg";